import React from 'react'
import { graphql, useFragment } from 'react-relay'
import { Trans } from '@lingui/react/macro'

import { XStack, YStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { PresentationCard } from '@newComponents/Presentation/PresentationCard'

import { PresentationSimilar_presentation$key } from './__generated__/PresentationSimilar_presentation.graphql'

export const PresentationSimilar = ({
  presentation,
}: {
  presentation: PresentationSimilar_presentation$key
}) => {
  const data = useFragment(
    graphql`
      fragment PresentationSimilar_presentation on Presentation {
        similarPresentations(first: 4) {
          edges {
            node {
              id
              ...PresentationCardNew_presentation
            }
          }
        }
      }
    `,
    presentation
  )

  if (!data.similarPresentations?.edges.length) {
    return null
  }

  return (
    <YStack gap='$5'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$color'><Trans>Similar Presentations</Trans></Strong>
        <Separator borderColor='$borderColor' />
      </XStack>

      <XStack flexWrap='wrap' gap='$4'>
        {data.similarPresentations.edges.map((edge) => {
          if (!edge.node) return null

          return (
            <YStack
              key={edge.node.id}
              flexBasis='100%'
              $gtMd={{ flexBasis: 'calc(50% - 8px)' }}
              $gtLg={{ flexBasis: 'calc(33.333% - 11px)' }}
              flexGrow={1}
              maxWidth='100%'
            >
              <PresentationCard
                presentation={edge.node}
                titleNumberOfLines={2}
                numberOfLines={3}
              />
            </YStack>
          )
        })}
      </XStack>
    </YStack>
  )
}
